import { render, staticRenderFns } from "./BottleInfo.vue?vue&type=template&id=683055ae&scoped=true&"
import script from "./BottleInfo.vue?vue&type=script&lang=js&"
export * from "./BottleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683055ae",
  null
  
)

export default component.exports